module.exports = __webpack_public_path__ + "img/checked.e9fa27d8.svg";